import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Langkawi escape early and enjoy the added luxury of a complimentary round-trip ferry transfer from Kuala Kedah to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-9510">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-9511">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-9512">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-9513" />
          <span data-id="element-9514">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-9515">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-9516">
          <div className="flex justify-between items-center" data-id="element-9517">
            <h2 className="text-xl font-bold" data-id="element-9518">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-9519">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-9520">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-9521">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-9522">
          <div className="p-6 border-r border-gray-200" data-id="element-9523">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9524">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9525">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9526">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-9527">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9528">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9529">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9530">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9531">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9532">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9533">
            <div data-id="element-9534">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9535">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9536">{reservation.booking.id}</p>
            </div>
            <div data-id="element-9537">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9538">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9539">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9540">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9541">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9542">
            <div data-id="element-9543">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9544">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9545">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-9546">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9547">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9548">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9549">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9550">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9551">
            <div data-id="element-9552">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9553">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9554">{reservation.room.name}</p>
            </div>
            <div data-id="element-9555">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9556">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9557">{reservation.room.view}</p>
            </div>
            <div data-id="element-9558">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9559">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9560">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9561">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9562">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-9563">
            <h4 className="text-base font-medium mb-4" data-id="element-9564">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9565">
              <div data-id="element-9566">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9567">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9568">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-9569">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9570">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9571">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-9572">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9573">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9574">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-9575">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9576">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9577">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-9578">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9579">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9580">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-9581">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9582">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9583">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-9584">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9585">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-9586">
            <div data-id="element-9587">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9588">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9589">{reservation.rate.name}</p>
            </div>
            <div data-id="element-9590">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9591">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9592">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-9593">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9594">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-9595">
            <div className="flex justify-between" data-id="element-9596">
              <p className="text-sm text-gray-500" data-id="element-9597">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9598">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-9599">
              <p className="text-sm text-gray-500" data-id="element-9600">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9601">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-9602">
              <p className="text-sm font-medium" data-id="element-9603">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-9604">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}